import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Api from '../../../../api/requests';
import { combineClassNames } from '../../../../app/functions';
import offerHomeImagePath from '../../../../assets/images/offer-home.png';
import offerCarImagePath from '../../../../assets/images/offer-car.png';
import offerTravelImagePath from '../../../../assets/images/offer-travel.png';
import './index.scss';

const INSURANCE_TYPE = {
    HOME :1 ,
    CAR : 2,
    TRAVEL: 3
}


const OffersSection = ({ isMobileApp }) => {
    const location = useLocation();
    
    const generalDeclaration = useSelector((store) => store.gd);
    const insurancePage = useSelector((store) => store.insurancePage);

    const [isLoading, setIsLoading] = useState(false);

    const offersTarget = isMobileApp ? '_self' : '_blank';

    // Note: (17/05/2023)
    // Temporarily, it was decided to give up on the functionality that generates a lead on the server via an API
    // request and redirects the user directly to it (the code that's commented below)
    // Instead, we take the user to an intermediate page that handles the lead generation and redirection
    const generateOfferLink = (insuranceType) => {

        switch (insuranceType) {
            case INSURANCE_TYPE.HOME:
                    return 'https://www.hot.co.il/%D7%94%D7%98%D7%91%D7%94/45953/'
            case INSURANCE_TYPE.CAR:
            case INSURANCE_TYPE.TRAVEL:
            default:
                break;
        }

        const baseDomain = generalDeclaration?.insurance_website_link_address ?? '/';

        const searchParams = new URLSearchParams(location.search);
        const accessToken = searchParams.get('accessToken') ?? '';

        let fullDomain = `${baseDomain}resource/insurance/redirect.php?insuranceType=${insuranceType}`;

        if (accessToken) {
            fullDomain += `&accessToken=${accessToken}`;
        }

        return fullDomain;
    };

    // const onServerResponse = (response) => {
    //     const leadLink = response?.data;
    //
    //     if (leadLink) {
    //         if (isMobileApp) {
    //             window.location = leadLink;
    //         } else {
    //             window?.open(leadLink, '_blank')?.focus();
    //         }
    //     }
    //
    //     setIsLoading(false);
    // };

    // const handleClick = (event) => {
    //     if (isLoading) return;
    //
    //     const insuranceType = event?.currentTarget?.dataset?.type ?? 0;
    //
    //     const searchParams = new URLSearchParams(location.search);
    //     const accessToken = searchParams.get('accessToken') ?? '';
    //
    //     Api.createInsuranceLead({
    //         payload: {
    //             insurance_type: insuranceType,
    //             access_token: accessToken,
    //         },
    //     }, onServerResponse);
    //
    //     setIsLoading(true);
    // };

    return (
        <section className={combineClassNames(
            'offers-section',
            isLoading && 'offers-section_loading',
        )}>
            <h2 className="offers-title">
                {insurancePage?.general?.offers_title}
            </h2>

            <ul className="offers-list">
                <li className="offers-list-item">
                    <a
                        href={generateOfferLink(insurancePage?.types?.HOME)}
                        target={offersTarget}
                        className="offer-container"
                    >
                        <img
                            src={offerHomeImagePath}
                            alt={insurancePage?.general?.house_insurance_title}
                            className="offer-image"
                        />

                        <span className="offer-name">
                            {insurancePage?.general?.house_insurance_title}
                        </span>
                    </a>
                </li>

                <li className="offers-list-item">
                    <a
                        href={generateOfferLink(insurancePage?.types?.CAR)}
                        target={offersTarget}
                        className="offer-container"
                    >
                        <img
                            src={offerCarImagePath}
                            alt={insurancePage?.general?.car_insurance_title}
                            className="offer-image"
                        />

                        <span className="offer-name">
                            {insurancePage?.general?.car_insurance_title}
                        </span>
                    </a>
                </li>

                <li className="offers-list-item">
                    <a
                        href={generateOfferLink(insurancePage?.types?.TRAVEL)}
                        target={offersTarget}
                        className="offer-container"
                    >
                        <img
                            src={offerTravelImagePath}
                            alt={insurancePage?.general?.travel_insurance_title}
                            className="offer-image"
                        />

                        <span className="offer-name">
                            {insurancePage?.general?.travel_insurance_title}
                        </span>
                    </a>
                </li>
            </ul>
        </section>
    );
};

export default OffersSection;
